<template>
  <div>
    <div class="notifications" style="z-index: 10; overflow: visible;">
      
      <drop-down ref="dropdown" :position="'dropdown-menu-left'" style="display: block;" @toggled="notificationsToggled">
        <template v-slot:button>
          <a id="notification-button" href="javascript:void(0)" :title="$t('notifications')"></a>
        </template>
        
        <div class="notification-list" @click.stop>
          <div class="container-fluid">
            <div class="row my-2">
              <div class="col align-self-end">
                <h2>{{ $t('notifications') }} <span v-if="hasNotifications" class="badge badge-primary ">{{ totalNotificationCount }}</span></h2>
              </div>
              <div class="col-auto align-self-end">
                <a class="btn btn-link" href="javascript:void(0)" @click="removeAll">{{ $t('delete_all') }}</a>
              </div>
              <div class="col-12">
                <hr class="ruler">
              </div>
            </div>
            <div v-if="!hasNotifications" class="row my-3">
              <div class="col">
                <p class="text-center">
                  {{$t('no_notifications')}}
                </p>
              </div>
            </div>
            <div class="row mb-3" v-for="(notification) in receivedNotifications" :key="notification.AutoID">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <component v-if="notification.component" v-bind="{data: notification.item}" :is="notification.component" @remove-toast="removeNotification(notification)"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </drop-down>
      
      <span v-if="hasUnreadNotifications" class="notification-count badge badge-pill badge-primary mr-1">{{ notificationCount }}</span>
    
    </div>
    
    <toaster ref="toaster" style="z-index: 5"/>
    <dialogs ref="dialogs" />
  </div>
</template>
<script>

import Vue from 'vue';
import Dialogs from 'components/Dialogs/Dialogs.vue';
import Toaster from 'components/Dialogs/Toaster.vue';
import ToastPlugin from '@/plugins/toaster.js';
import DropDown from 'components/DropDown.vue';
import  * as NotificationListeners from 'libs/notificationlistener';
import NotificationsController from 'controller/notificationscontroller';

const messageComponent = () => import('./NotificationToast.vue');
const controller = new NotificationsController();

const useHttp2 = () => (performance.getEntriesByType('navigation')[0].nextHopProtocol === 'h2');

export default {
  name: 'App',
  components: {
    'toaster': Toaster,
    'dialogs': Dialogs,
    'drop-down': DropDown
  },
  data () {
    return {
      firstLoad: true,
      receivedNotifications: [],
      listener: useHttp2() ? new NotificationListeners.EventStreamNotificationListener() : new NotificationListeners.PollNotificationListener()
    };
  },
  created () {
  },
  mounted () {
    const self = this;
    Vue.use(ToastPlugin, { toaster: self.$refs.toaster, dialogs: self.$refs.dialogs });
    this.listener.Bus.$on('new-notifications', this.processNotificationEvent);
  },
  methods: {
    notificationsToggled (open) {
      if (open === true && this.receivedNotifications.length > 0) {
        this.markAllAsRead(this.receivedNotifications);
      } else {
        // closed 
      }
    },
    processNotificationEvent(notifications) {
      if (notifications.length > 0) {
        let mappedMessages = notifications.map(x => toMessage(x));
        
        // add to collection
        mappedMessages.forEach(notification => this.addNotification(notification));
        
      }
      this.firstLoad = false;
    },
    addNotification(notification) {
      this.receivedNotifications.push(notification);

      if (!this.firstLoad) {
        this.showToaster(notification);
      }
    },
    removeAll () {
      this.receivedNotifications.forEach(x => this.removeNotification(x));
    },
    removeNotification(notification) {
      this.receivedNotifications = this.receivedNotifications.filter(x => x.AutoID !== notification.AutoID);
      if (!this.hasNotifications) {
        // close
        this.close();
      }
    },
    close() {
      this.$refs.dropdown.toggleDropDown();
    },
    showToaster(notification) {
      this.$toaster.showComponent({ component: messageComponent, bind: { data: notification.item }}, 8000);
    },
    async markAllAsRead(items) {
      try {
        let mapped = items.map(x => x.AutoID);
        let result = await controller.MarkAsRead(mapped);
        if (result && result.IsSuccess) {
          this.receivedNotifications.filter(x => mapped.some(m => m === x.AutoID)).forEach(x => {
            x.read = true;
          });
        }
      } catch(error) {
        console.error(error);
      }
    }
  },
  computed: {
    notificationCount() {
      return this.receivedNotifications.filter(x => x.read === false).length;
    },
    totalNotificationCount () {
      return this.receivedNotifications.length;
    },
    hasUnreadNotifications () {
      return this.notificationCount > 0;
    },
    hasNotifications() {
      return this.totalNotificationCount > 0;
    }
  }
};

const toMessage = (item) => {
  return {
    AutoID: item.AutoID,
    item: item,
    read: false,
    component: messageComponent
  };
};

</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

.ruler {
  width: 100%;
}
#notification-button {
  width: 40px;
  height: 40px;
  display: inline-block;
  background-size: 24px;
  background-position: center center;
  background-repeat: no-repeat;
}
.notifications {
  position: relative;
  z-index: 10;
  // pointer-events: none;
  .overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
  .notification-count {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.notification-list {
  width: 400px;
  max-width: calc(100vw - 30px);
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
}
</style>
